import React from 'react'

export default function Experience() {
  return (
    <>
        <section className="resume-section" id="experience">
          <div className="resume-section-content">
            <h2 className="mb-5">Experience</h2>
            <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
              <div className="flex-grow-1">
                <h3 className="mb-0">Consultant (Team Lead / Tech Lead)</h3>
                <div className="subheading mb-3">Eviden (Atos-Syntel)</div>
                <p>Designed and developed customer-facing applications using .NET Framework/Core resulting in increased efficiency and productivity.s a member of an agile development team, I am responsible for end-to-end development of user stories and features.
                   Involved in different agile ceremonies like backlog refinement, sprint planning, sprint retrospective, sprint demo etc. Participate in architecture, design and code reviews, technical innovation.
                   Writing Unit Tests and automated system tests.
                </p>
              </div>
              <div className="flex-shrink-0"><span className="text-primary">March 2013 - Present</span></div>
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
              <div className="flex-grow-1">
                <h3 className="mb-0">SDE, Analyst</h3>
                <div className="subheading mb-3">Fiserv</div>
                <p>
                Developed and maintained web applications resulting in increased efficiency and
                productivity.Designed and developed a web application using ASP.NET MVC resulting in a 25%
                increase in user engagement.Implemented Git source control for team collaboration resulting in a 50%
                reduction in merge conflicts.Involved in different agile ceremonies like backlog refinement, sprint planning,
                sprint retrospective, sprint demo etc.Designed and implemented unit testing resulting in a 70% increase in code
                coverage.
                </p>
              </div>
              <div className="flex-shrink-0"><span className="text-primary">August 2019 - June 2021</span></div>
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
              <div className="flex-grow-1">
                <h3 className="mb-0">Sr. Engineer</h3>
                <div className="subheading mb-3">Harman Connected Services</div>
                <p>Developed and maintained web applications resulting in increased efficiency and productivity.</p>
              </div>
              <div className="flex-shrink-0"><span className="text-primary">February 2015 - August 2019</span></div>
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-between">
              <div className="flex-grow-1">
                <h3 className="mb-0">Software Developer</h3>
                <div className="subheading mb-3">Elogmar Enterprises</div>
                <p>Developed and maintained web applications resulting in increased efficiency and productivity.</p>
              </div>
              <div className="flex-shrink-0"><span className="text-primary">December 2013 - February 2015</span></div>
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
              <div className="flex-grow-1">
                <h3 className="mb-0">Software Developer</h3>
                <div className="subheading mb-3">InfoSoft Global tech</div>
                <p>Developed and maintained web applications resulting in increased efficiency and productivity.
                </p>
              </div>
              <div className="flex-shrink-0"><span className="text-primary">January 2012 - December 2013</span></div>
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
              <div className="flex-grow-1">
                <h3 className="mb-0">Jr. Programmer</h3>
                <div className="subheading mb-3">Elink Technologies Pvt Ltd.</div>
                <p>Developed and maintained web applications resulting in increased efficiency and productivity.
                </p>
              </div>
              <div className="flex-shrink-0"><span className="text-primary">June 2011 - january 2012 </span></div>
            </div>
          </div>
        </section>
    </>
  )
}
